export class Semaphore {
  private availableSlots: number;
  private readonly waiting: (() => void)[] = [];

  constructor(slots: number) {
    this.availableSlots = slots;
  }

  async acquire(): Promise<void> {
    if (this.availableSlots > 0) {
      this.availableSlots -= 1;
      return;
    }

    await new Promise<void>((resolve) => this.waiting.push(resolve));
  }

  release(): void {
    const next = this.waiting.shift();

    if (next) {
      next();
      return;
    }

    this.availableSlots += 1;
  }

  get hasFreeSlot(): boolean {
    return this.availableSlots > 0;
  }
}
